document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile menu ---------- */
  var toggle = document.querySelector('[data-mobile-toggle]');
  var drawer = document.querySelector('[data-mobile-drawer]');
  var overlay = document.querySelector('[data-mobile-overlay]');
  var closeBtn = document.querySelector('[data-mobile-close]');
  function openDrawer(){ drawer && drawer.classList.add('open'); overlay && overlay.classList.add('open'); }
  function closeDrawer(){ drawer && drawer.classList.remove('open'); overlay && overlay.classList.remove('open'); }
  toggle && toggle.addEventListener('click', openDrawer);
  closeBtn && closeBtn.addEventListener('click', closeDrawer);
  overlay && overlay.addEventListener('click', closeDrawer);

  /* ---------- Hero sliders (supports multiple on page) ---------- */
  document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
    var slides = slider.querySelectorAll('.hero-slider__slide');
    var dots = slider.querySelectorAll('.hero-slider__dots button');
    var index = 0;
    var autoplay = slider.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(slider.getAttribute('data-interval') || '5000', 10);
    function show(i) {
      slides.forEach(function (s, idx) { s.classList.toggle('active', idx === i); });
      dots.forEach(function (d, idx) { d.classList.toggle('active', idx === i); });
      index = i;
    }
    slider.querySelectorAll('[data-hero-next]').forEach(function (btn) {
      btn.addEventListener('click', function () { show((index + 1) % slides.length); });
    });
    slider.querySelectorAll('[data-hero-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () { show((index - 1 + slides.length) % slides.length); });
    });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i); }); });
    if (slides.length) show(0);
    if (autoplay && slides.length > 1) {
      setInterval(function () { show((index + 1) % slides.length); }, interval);
    }
  });

  /* ---------- Product card image swap on swatch hover ---------- */
  document.querySelectorAll('.product-card__swatch').forEach(function (sw) {
    sw.addEventListener('mouseenter', function () {
      var card = sw.closest('.product-card');
      var img = card.querySelector('.product-card__media img.secondary');
      var url = sw.getAttribute('data-image');
      if (img && url) img.src = url;
    });
  });

  /* ---------- Product page: variant swatches + gallery ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var swatches = form.querySelectorAll('.variant-swatch');
    var priceEl = form.querySelector('[data-price]');
    var comparePriceEl = form.querySelector('[data-compare-price]');
    var offEl = form.querySelector('[data-off]');
    var variantInput = form.querySelector('[name="id"]');
    var mainImage = document.querySelector('[data-gallery-main] img');

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('active'); });
        sw.classList.add('active');
        if (variantInput) variantInput.value = sw.getAttribute('data-variant-id');
        if (priceEl && sw.getAttribute('data-price')) priceEl.textContent = sw.getAttribute('data-price');
        if (comparePriceEl && sw.getAttribute('data-compare')) comparePriceEl.textContent = sw.getAttribute('data-compare');
        if (offEl && sw.getAttribute('data-off')) offEl.textContent = sw.getAttribute('data-off');
        if (mainImage && sw.getAttribute('data-image')) mainImage.src = sw.getAttribute('data-image');
      });
    });

    /* quantity selector */
    var qtyInput = form.querySelector('[data-qty-input]');
    form.querySelectorAll('[data-qty-minus]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
      });
    });
    form.querySelectorAll('[data-qty-plus]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
      });
    });
  });

  /* ---------- Gallery thumbnails ---------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-gallery-main] img');
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (main) main.src = thumb.getAttribute('data-full') || thumb.src;
    });
  });

  /* ---------- Add to cart (AJAX) ---------- */
  function refreshCartDrawer() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
      var container = document.getElementById('cart-drawer-items');
      var subtotal = document.getElementById('cart-drawer-subtotal');
      if (!container) return;
      if (cart.item_count === 0) {
        container.innerHTML = '<div class="empty-state"><p>Your cart is empty</p></div>';
      } else {
        container.innerHTML = cart.items.map(function (item) {
          return '<div class="cart-line">' +
            '<img src="' + item.image + '" alt="' + item.product_title + '">' +
            '<div><div class="cart-line__title">' + item.product_title + '</div>' +
            '<div class="cart-line__opts">' + (item.variant_title || '') + '</div>' +
            '<div class="cart-line__opts">Qty: ' + item.quantity + ' &middot; Rs. ' + (item.final_price / 100).toFixed(0) + '</div></div>' +
            '</div>';
        }).join('');
      }
      if (subtotal) subtotal.textContent = 'Rs. ' + (cart.total_price / 100).toFixed(0);
    });
  }
  refreshCartDrawer();

  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      document.getElementById('cart-drawer').classList.remove('open');
    });
  });
  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      document.getElementById('cart-drawer').classList.add('open');
    });
  });

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var mode = form.getAttribute('data-mode');
      if (mode === 'buy-now') return; // let it submit normally to /cart/add then redirect handled server-side via return_to
      if (form.getAttribute('data-ajax') !== 'true') return;
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          refreshCartDrawer();
          var drawerEl = document.getElementById('cart-drawer');
          if (drawerEl) drawerEl.classList.add('open');
        })
        .catch(function (err) { console.error(err); });
    });
  });

  /* ---------- FAQ / accordions handled natively via <details> ---------- */

  /* ---------- Newsletter form (Shopify customer form handles submission natively) ---------- */
});
